import {Component, Input, ViewChild} from '@angular/core';
import {Question} from 'classes/question';

@Component({
  selector: 'constructs-questions',
  templateUrl: './constructs-questions.component.html',
  styleUrls: ['./constructs-questions.component.css'],
})
export class ConstructsQuestionsComponent {

  // 'form' is used to allow the parent component to retrieve the validation
  // status of the nested form.
  @ViewChild('form') private form: any; // tslint:disable-line:no-any
  @Input() private language: string;
  private questionsExpanded: Array<boolean>;
  private hasSolution: Array<boolean>;
  private hasVarName: Array<boolean>;

  private _questions: Array<Question>;

  @Input()
  set questions(value: Array<Question>) {
    console.log("##");
    this.hasSolution = []
    for (let i = 0; i < value.length; i++) {
      this.hasSolution[i] = value[i].solution !== undefined;
    }
    this.hasVarName = []
    for (let i = 0; i < value.length; i++) {
      this.hasVarName[i] = value[i].varName !== undefined;
    }
    this._questions = value;
  };

  get questions(): Array<Question> {
    return this._questions;
  }

  constructor() {
    this.language = 'de';
    this.questions = [];
    this.questionsExpanded = [];
    this.questionsExpanded[0] = true;
  }

  public addEmptyQuestion(): void {
    const question: Question = new Question();
    question.minLabel = {de: '', en: ''};
    question.maxLabel = {de: '', en: ''};
    console.log(this.hasSolution);
    this.hasSolution.push(false);
    this.hasVarName.push(false);
    this._questions.push(question);
    this.expandLastQuestionOnly();
  }

  private removeQuestion(index: number): void {
    this.hasSolution.splice(index, 1);
    this.questions.splice(index, 1);
  }

  private questionIsExpanded(index: number): boolean {
    if (!this.questionsExpanded[index]) {
      return false;
    }
    return this.questionsExpanded[index];
  }

  private expandLastQuestionOnly(): void {
    this.questionsExpanded = [];
    this.questionsExpanded[this.questions.length - 1] = true;
  }

  private changeQuestionType(question: Question): void {
    delete question.solution;
  }

  private addOption(question) {
    if ( !question.options ) {
      question.options = [];
    }
    question.options.push({de: '', en: ''});
  }

  private deleteOption(question, j) {
    if ( question.solution.length > j ) {
      question.solution = question.solution.substring(0, j) + question.solution.substring(j+1);
    }
    question.options.splice(j, 1);
  }

  private isMcSolution(question, j): boolean {
    return question.solution && (question.solution.length > j) && (question.solution.charAt(j) == '1');
  }

  private changeMcSolution(question: Question, j: number, evt): void {
    let s = question.solution ? question.solution : '';
    while ( s.length <= j ) {
      s += '0'
    }
    s = s.substring(0, j) + (evt.target.checked ? '1' : '0') + s.substring(j+1);
    question.solution = s;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-details/constructs-questions/constructs-questions.component.ts